// extracted by mini-css-extract-plugin
export default {"container":"Certificates_container__QcQPN","title":"Certificates_title__gJ2pq","certificates":"Certificates_certificates__bwFpj"};